import { Component } from 'react';
import { connect } from 'react-redux';
import { RouteConstants } from "../route/services/RouteConstants";
import { getLanguage } from "../../store/rootReducer";
import HrbTranslate from '../language/HrbTranslate';
import logo from '../../assets/images/hrb-logo-horizontal.svg';
import eyeIcon from '../../assets/images/eye-icon.svg';
import dict from '../../resources/data/dict.json';
import './UpdateEmailStart.scss';
import api from '../../services/api/AccountUpdateApi';
import { ErrorCodes, ErrorMessages } from '../../configurations/ErrorConstants';
import ValidationService from '../registration/services/ValidationService';
import { HeapEvents, trackEvent } from '../../services/util/AnalyticsUtil';

class UpdateEmailStart extends Component {

  constructor(props) {
    super(props);
      this.state = {
      errorMessage: null,
      username: '',
      password: '',
      showPassword: false,
      token: null,
      isAccountLocked: false,
      usernameError: null,
      passwordError: null
    };
  }

  handleUsernameChange = (e) => {
    this.setState({ username: e.target.value });
  };

  handleUsernameBlur = () => {
    this.setState({ usernameError: null, errorMessage: null });
  };

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  };

  handlePasswordBlur = () => {
    this.setState({ passwordError: null, errorMessage: null });
  };

  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.submitStartForm();
  };

  submitStartForm = async () => {
    this.setState({ errorMessage: null, usernameError: null, passwordError: null });

    let hasError = false;
    let usernameError = null;
    let passwordError = null;

    if (!this.state.username || this.state.username.trim() === '') {
      usernameError = 'error_email_empty';
      hasError = true;
    } else {
      const hasAtSymbol = this.state.username.includes('@');
      
      if (hasAtSymbol) {
        if (!ValidationService.isValidEmail(this.state.username, true)) {
          usernameError = 'error_email_invalid';
          hasError = true;
        }
      } else {
        const usernameRegex = /^[a-zA-Z0-9._-]+$/;
        if (!usernameRegex.test(this.state.username)) {
          usernameError = 'error_email_invalid';
          hasError = true;
        }
      }
    }

    if (!this.state.password || this.state.password.trim() === '') {
      passwordError = 'error_password_empty';
      hasError = true;
    }

    if (hasError) {
      this.setState({ usernameError, passwordError });
      return;
    }
    
    trackEvent(HeapEvents.ACCONT_RECOVERY_SUBMITTED_CREDENTIALS);

    var token  = await api.getTokenAsync(this.state.username);
    if(token === null) {
      this.setState({ errorMessage: "An error occurred. Please try again." });
      return;
    }

    var request = {
      username: this.state.username,
      password: this.state.password,
      token
    }

    var response = await api.verifyUserAsync(request);
    
    if(response.errorCode) {
      if(response.errorCode === ErrorCodes.INVALID_CREDENTIALS) {
        this.setState({ errorMessage: ErrorMessages.INVALID_CREDENTIALS });
      } else if(response.errorCode === ErrorCodes.ACCOUNT_LOCKED) {
        this.setState({ 
          errorMessage: ErrorMessages.ACCOUNT_LOCKED,
          isAccountLocked: true
        });
      } else {
        this.setState({ errorMessage: ErrorMessages.INVALID_CREDENTIALS });
      }
      return;
    }

    if(response.token && response.securityQuestionId) {
      this.props.history.push({
        pathname: RouteConstants.UPDATE_EMAIL_SECURITY,
        state: { 
          username: this.state.username,
          token: response.token,
          securityQuestionId: response.securityQuestionId
        }
      });
    }
  };

  render() {
    const { language } = this.props;
    
    return (
      <div className="hrb-update-email-start-card">
        <div className="hrb-update-email-start-logo">
          <img src={logo} alt="H&R Block" />
        </div>

        <h1 className="hrb-update-email-start-title">
          <HrbTranslate text="update_email.start.mobile_title" />
        </h1>

        <p className="hrb-update-email-start-intro">
          <HrbTranslate text="update_email.start.intro" />
        </p>

        {this.state.errorMessage && (
          <div className="hrb-update-email-start-error">
            <HrbTranslate text={`update_email.start.${this.state.errorMessage}`} />
          </div>
        )}

        {!this.state.isAccountLocked && (
          <>
            <div className="hrb-update-email-start-input-wrapper">
              <div className={`hrb-update-email-start-input-group ${this.state.usernameError ? 'has-error' : ''}`}>
                <input
                  type="text"
                  className="hrb-update-email-start-input"
                  placeholder={dict.update_email.start.email_username_field_label[language.toLowerCase()]}
                  value={this.state.username}
                  onChange={this.handleUsernameChange}
                  onBlur={this.handleUsernameBlur}
                />
              </div>
              {this.state.usernameError && (
                <div className="hrb-update-email-start-field-error">
                  <HrbTranslate text={`update_email.start.${this.state.usernameError}`} />
                </div>
              )}
            </div>

            <div className="hrb-update-email-start-input-wrapper">
              <div className={`hrb-update-email-start-input-group ${this.state.passwordError ? 'has-error' : ''}`}>
                <input
                  type={this.state.showPassword ? "text" : "password"}
                  className="hrb-update-email-start-input"
                  placeholder={dict.update_email.start.password_field_label[language.toLowerCase()]}
                  value={this.state.password}
                  onChange={this.handlePasswordChange}
                  onBlur={this.handlePasswordBlur}
                />
                <button
                  type="button"
                  className="hrb-update-email-start-eye-icon"
                  onClick={this.togglePasswordVisibility}
                  aria-label="Toggle password visibility"
                >
                  <img src={eyeIcon} alt="" />
                </button>
              </div>
              {this.state.passwordError && (
                <div className="hrb-update-email-start-field-error">
                  <HrbTranslate text={`update_email.start.${this.state.passwordError}`} />
                </div>
              )}
            </div>

            <button
              className="hrb-update-email-start-button"
              onClick={this.submitStartForm}
            >
              <HrbTranslate text="update_email.start.continue" />
            </button>

            <button
              className="hrb-update-email-start-back"
              onClick={() => this.props.history.go(-1)}
            >
              <HrbTranslate text="update_email.start.back" />
            </button>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  };
};

export default connect(mapStateToProps)(UpdateEmailStart);
